import "../../styles/all.css"
import "../../styles/theme.css"
import "./event.css"
import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
function Events(){
    return(
        <>
        <div className="event">
              <div className="head">
                <h4>Upcoming Events</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="content">
                <div className="box">
                    <div className="information">
                        <div className="text">
                            <h4>20</h4>
                            <h5>FRI</h5>
                        </div>
                        <div className="timer">
                            <h4>09:00 PM - 10:30 Pm</h4>
                            <h5>Meeting For Campagin With Sales Team</h5>
                        </div>
                    </div>
                    <div className="image">
                        <img src={personone} alt="" />
                        <img src={persontwo} alt="" />
                        <img src={personthree} alt="" />
                        <img src={personfour} alt="" />
                        <img src={personfive} alt="" />


                    </div>

                </div>
                <div className="box">
                    <div className="information">
                        <div className="text">
                            <h4>22</h4>
                            <h5>Sun</h5>
                        </div>
                        <div className="timer">
                            <h4>11:00 PM - 12:00 Pm</h4>
                            <h5>Meeting For Campagin With Sales Team</h5>
                        </div>
                    </div>
                    <div className="image">
                        <img src={personone} alt="" />
                        <img src={persontwo} alt="" />
                        <img src={personthree} alt="" />
                        <img src={personfour} alt="" />
                        <img src={personfive} alt="" />


                    </div>

                </div>
                 <div className="box">
                    <div className="information">
                        <div className="text">
                            <h4>25</h4>
                            <h5>Thu</h5>
                        </div>
                        <div className="timer">
                            <h4>10:30 PM - 11:30 Pm</h4>
                            <h5>Meeting For Campagin With Sales Team</h5>
                        </div>
                    </div>
                    <div className="image">
                        <img src={personone} alt="" />
                        <img src={persontwo} alt="" />
                        <img src={personthree} alt="" />
                        <img src={personfour} alt="" />
                        <img src={personfive} alt="" />


                    </div>

                </div>
                 <div className="box">
                    <div className="information">
                        <div className="text">
                            <h4>18</h4>
                            <h5>Wed</h5>
                        </div>
                        <div className="timer">
                            <h4>09:00 PM - 10:30 Pm</h4>
                            <h5>Meeting For Campagin With Sales Team</h5>
                        </div>
                    </div>
                    <div className="image">
                        <img src={personone} alt="" />
                        <img src={persontwo} alt="" />
                        <img src={personthree} alt="" />
                        <img src={personfour} alt="" />
                        <img src={personfive} alt="" />


                    </div>

                </div>
                <div className="box">
                    <div className="information">
                        <div className="text">
                            <h4>28</h4>
                            <h5>Thu</h5>
                        </div>
                        <div className="timer">
                            <h4>11:00 PM - 12:00 Pm</h4>
                            <h5>Meeting For Campagin With Sales Team</h5>
                        </div>
                    </div>
                    <div className="image">
                        <img src={personone} alt="" />
                        <img src={persontwo} alt="" />
                        <img src={personthree} alt="" />
                        <img src={personfour} alt="" />
                        <img src={personfive} alt="" />


                    </div>

                </div>

                
                


            </div>

        </div>
        </>
    )
}
export default Events